import React from "react";
import { connect } from "react-redux";
import { EnquiryActionJson } from "../../../DynamicFormsJson/MastersJSON/enquiryAction";
import { getEnquiryAction } from "../../../Slice/enquiryOperations.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { EnquiryActionColumns } from "../../../tableColumns/table-columns";

class EnquiryAction extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { enquiryAction, getEnquiryAction } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={EnquiryActionJson.formPath}
                    screenTitle={EnquiryActionJson.screenTitle}
                    fieldMeta={EnquiryActionJson.fieldMeta}
                    showPdfDownload={EnquiryActionJson.showPdfDownload}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={EnquiryActionJson.pdfFileName}
                    excelFileName={EnquiryActionJson.excelFileName}
                    showAddButton={EnquiryActionJson.showAddButton}
                    tableColumnsToFilter={EnquiryActionJson.tableColumnsToFilter}
                    tableColumns={EnquiryActionColumns}
                    tableData={enquiryAction?.enquiryAction}
                    getTableData={getEnquiryAction}
                    apiBaseURL={EnquiryActionJson.apiBaseURL}
                    baseIdColumn={EnquiryActionJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={EnquiryActionJson.noteValue}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    isActiveURL={EnquiryActionJson.isActiveURL}
                    isActiveURLGET={true}
                    showView={false}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    enquiryAction: state.enquiryOperations,
});

const mapDispatchToProps = {
    getEnquiryAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryAction);